module.exports = __webpack_public_path__ + "static/media/eybcard.8eebcafc.png";